module.exports = __webpack_public_path__ + "img/xiaobianzi.2ea4bc94.gif";